import { ContentKind } from '~/generated/graphql';
import { isSmDown } from '~/lib/responsive';
import type { ContentFiltersState } from './filters';
import type { useFilterParams } from './searchParams';

const INITIAL_KIND = [
  { label: 'App', selected: false, value: ContentKind.App },
  { label: 'Image', selected: false, value: ContentKind.Image },
  { label: 'Overlay', selected: false, value: ContentKind.Overlay },
  { label: 'Pdf', selected: false, value: ContentKind.Pdf },
  { label: 'PowerPoint', selected: false, value: ContentKind.Powerpoint },
  { label: 'Video', selected: false, value: ContentKind.Video },
];

export const allUnselectedState: ContentFiltersState = {
  filters: {
    kind: { open: false, items: INITIAL_KIND },
    tags: { open: false, items: [] },
  },
  panel: { open: false },
};

export const useIntialState = (params: ReturnType<typeof useFilterParams>) => {
  const smDown = isSmDown();
  return {
    filters: {
      kind: {
        open: params.kind.length > 0,
        items: INITIAL_KIND.map((x) => ({ ...x, selected: params.kind.includes(x.value) })),
      },
      tags: { open: false, items: [] },
    },
    panel: { open: !smDown && Object.values(params).flat().length > 0 },
  };
};
